import { Box, Divider, Modal } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { twMerge } from 'tailwind-merge';

import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({});

export default function WarningTopUp(props) {
	const { open, onClose, onAction } = props;

	const { handleSubmit } = useForm({
		resolver: yupResolver(schema),
		defaultValues: {},
	});

	const onSubmit = () => {
		onAction();
	};

	return (
		<Modal open={open} onClose={onClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[360px]'>
				<span className='font-bold text-center text-md'>Warning</span>
				<Divider />
				<form onSubmit={handleSubmit(onSubmit)} className={twMerge('flex flex-col gap-4')}>
					<span className='font-bold text-center text-md'>
						Are you sure you want to proceed with this action? once you proceed to go back{' '}
						<span className='mt-2 font-semibold text-red-600'>The transaction will be cancelled.</span>
					</span>
					<Divider />
					<div className={twMerge('flex gap-2 ml-auto')}>
						<button className='text-black bg-white border border-black btn-actions min-w-max' onClick={onClose}>
							No
						</button>

						<button className='bg-black btn-actions min-w-max' type='submit'>
							Yes
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
